import React, { Dispatch, SetStateAction } from "react";
import { BsChatLeft, BsQuestionCircle } from "react-icons/bs";

import { Card, Content } from "./styles";

type ContentFaleConoscoProps = {
  setPage: Dispatch<SetStateAction<string>>;
};

const ContentFaleConosco = ({
  setPage,
}: ContentFaleConoscoProps): JSX.Element => {
  const openUlly = (): void => {
    const chatbotButton = document?.querySelector("#hi-custom-widget") as any;
    chatbotButton?.click();
  };

  return (
    <Content>
      <Card onClick={() => setPage("duvidas-frequentes")}>
        <BsQuestionCircle />
        <span>Dúvidas frequentes</span>
      </Card>
      <Card onClick={() => openUlly()}>
        <BsChatLeft />
        <span>Falar via chat</span>
      </Card>
    </Content>
  );
};

export default ContentFaleConosco;
